import { podFulFillmentUtils } from '@thd-olt-component-react/fulfillment';

export const FULFILLMENT_METHODS = {
  STH: 'ShipToHome',
  BOPIS: 'BOPIS',
  STORE: 'ShipToStore',
  BODFS: 'DeliverFromStore',
  APPLIANCE: 'DirectDelivery'
};

export const ABBREVIATED_FULFILLMENT_METHODS = {
  ShipToHome: 'sth',
  BOPIS: 'bopis',
  ShipToStore: 'boss',
  DeliverFromStore: 'bodfs',
  DirectDelivery: 'appl',
};

export const getFulfillmentLocation = ({ fulfillmentMethod, store = {} }) => {
  switch (fulfillmentMethod) {
    case FULFILLMENT_METHODS.STH:
      return 'DirectShip';
    case FULFILLMENT_METHODS.BOPIS:
    case FULFILLMENT_METHODS.STORE:
      return store.storeId || '';
    case FULFILLMENT_METHODS.BODFS:
      return store.storeZip || '';
    default:
      return null;
  }
};

export const createPriorityOfFulfillments = (selectedFulfillment) => {
  const allFulfillments = [
    FULFILLMENT_METHODS.STH,
    FULFILLMENT_METHODS.BOPIS,
    FULFILLMENT_METHODS.STORE,
    FULFILLMENT_METHODS.BODFS
  ];

  if (selectedFulfillment) {
    allFulfillments.unshift(selectedFulfillment);
  }

  return Array.from(new Set(allFulfillments));
};

export const getRelatedFulfillmentMethods = (fulfillmentMethod) => {
  switch (fulfillmentMethod) {
    case FULFILLMENT_METHODS.STH:
    case FULFILLMENT_METHODS.STORE:
      return [FULFILLMENT_METHODS.STH, FULFILLMENT_METHODS.STORE];
    case FULFILLMENT_METHODS.BOPIS:
      return [FULFILLMENT_METHODS.BOPIS];
    default:
      return [];
  }
};

export const updateAvailableFulfillments = (fulfillmentMethod = '', availableFulfillments = {}, quantity = 0) => {
  const updatedFulfillments = { ...availableFulfillments };

  if (quantity > 0) {
    getRelatedFulfillmentMethods(fulfillmentMethod)
      .forEach((relatedFulfillment) => {
        if (updatedFulfillments[relatedFulfillment] > 0) {
          updatedFulfillments[relatedFulfillment] -= quantity;
        }
      });
  }

  return updatedFulfillments;
};

export const getFulfillmentMethodFromCart = (promoCartItemEntry) => (
  promoCartItemEntry.fulfillmentModel
    .find((ful) => ful.selected)?.fulfillmentMethod
);

export const getCurrentlyAvailable = (promoCartItemModel, product) => {
  let availableFulfillments = podFulFillmentUtils.getAllFulfillmentInventories(product);

  Object.keys(promoCartItemModel?.fulfillments || {}).forEach((fulfillmentMethod) => {
    const qtyInCart = promoCartItemModel.fulfillments[fulfillmentMethod].quantity || 0;

    if (qtyInCart > 0) {
      availableFulfillments = updateAvailableFulfillments(fulfillmentMethod, availableFulfillments, qtyInCart);
    }
  });

  return availableFulfillments;
};

const locationHasQuantity = (location) => location.inventory?.quantity > 0;

const serviceHasLocationWithInventory = (service) => {
  return (service.locations || [])
    .some((location) => (location.isAnchor || location.locationId === '8119')
      && locationHasQuantity(location));
};

const fulfillmentOptionCanFulfill = (fulfillmentOption) => (
  (fulfillmentOption.services || []).some(serviceHasLocationWithInventory)
);

export const isFulfillable = (item) => (
  (item.fulfillment?.fulfillmentOptions || []).some(fulfillmentOptionCanFulfill)
);
